// src/components/feedpost/PostEditModal.js
import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const PostEditModal = ({ isOpen, onClose, post, sellerId, refreshPosts }) => {
  const [content, setContent] = useState(post?.content || "");
  const [productUrl, setProductUrl] = useState(post?.product_url || "");
  const [mediaUrl, setMediaUrl] = useState(post?.media_url || []);
  const [uploading, setUploading] = useState(false);

  if (!isOpen || !post) return null;

  // ✅ Handle media upload
  const handleMediaUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const res = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: [{ fileName: file.name, fileType: file.type }] },
        { headers: { token } }
      );

      const { presignedUrl, fileUrl } = res.data.directory[0];
      await axios.put(presignedUrl, file, {
        headers: { "Content-Type": file.type },
      });

      setMediaUrl([{ media_type: file.type.startsWith("video") ? "video" : "image", url: fileUrl }]);
    } catch (err) {
      alert("❌ Media upload failed");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  // ✅ Submit edited post
  const handleSave = async () => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const payload = {
        post_id: post.id,
        user_id: post.user_id,
        content,
        media_url: mediaUrl,
        is_donation: post.is_donation,
        start_date: post.start_date,
        end_date: post.end_date,
        category: post.category_id,
        donation_target: post.donation_target,
        title: post.title,
        isPublic: post.isPublic,
        share_text: post.share_text,
        is_seller_post: post.is_seller_post ? "true" : "false",
        seller_id: sellerId?.toString(),
        product_url: productUrl,
      };

      await axios.post(`${API_BASE_URL}/post/edit-post`, payload, {
        headers: { token },
      });

      alert("✅ Post updated successfully");
      onClose();
      if (refreshPosts) refreshPosts(); // reload post list in profile
    } catch (err) {
      console.error("❌ Error editing post:", err);
      alert("Failed to update post");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-[90%] md:w-[600px] relative">
        <button className="absolute top-2 right-2" onClick={onClose}>✕</button>
        <h2 className="text-xl font-semibold mb-4">Edit Post</h2>

        {/* Content */}
        <textarea
          className="w-full border p-2 mb-3"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Edit your content..."
        />

        {/* Product URL */}
        <input
          className="w-full border p-2 mb-3"
          value={productUrl}
          onChange={(e) => setProductUrl(e.target.value)}
          placeholder="Product URL"
        />

        {/* Media preview */}
        {mediaUrl?.length > 0 && (
          <div className="mb-3">
            {mediaUrl[0].media_type === "video" ? (
              <video src={mediaUrl[0].url} controls className="w-full h-40 object-cover" />
            ) : (
              <img src={mediaUrl[0].url} alt="media" className="w-full h-40 object-cover" />
            )}
          </div>
        )}

        {/* Upload new media */}
        <input type="file" accept="image/*,video/*" onChange={handleMediaUpload} />
        {uploading && <p className="text-sm text-gray-500">Uploading...</p>}

        {/* Buttons */}
        <div className="flex justify-end gap-4 mt-4">
          <button className="bg-gray-300 px-4 py-2 rounded" onClick={onClose}>Cancel</button>
          <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostEditModal;
